import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
  text: {
    fontSize: 14,
    paddingLeft: 10,
  },
}));
